export default __webpack_public_path__ + "062dfcd33abd1789874edb591e6cf51b.png";